module.exports = __webpack_public_path__ + "img/2_265.c28f3c35.png";